const actionTypes = {
    
    SET_LOADING_MSG: 'SET_LOADING_MSG',
    SET_MODAL: 'SET_MODAL',
    CLOSE_MODAL: 'CLOSE_MODAL'
}

export {actionTypes};